import React from 'react'
import { Link } from 'react-router-dom'

import './game.css'
import WITHEBOARD from '../../assets/board-white.svg'
import BLACKBOARD from '../../assets/board-black.svg'

import PLAYER1 from '../../assets/player-1.png'
import PLAYER2 from '../../assets/player-2.png'
import PLAYERCPU from '../../assets/player-cpu.png'
import PLAYERCPURED from '../../assets/player-cpu-red.png'


import { Grid } from '../grid/Grid'
import { usePlay } from '../../hooks/usePlay'
import { Timer } from '../timer/Timer'
import { Winner } from '../winner/Winner'
import { Modal } from '../modal/Modal'
import { Logo } from '../logo/Logo'

const Game = ({ cpu }) => {

  const width = window.innerWidth
  const { grid,
    setNewDisk,
    player,
    timerCounter,
    setTimerCounter,
    winner,
    player1Wins,
    player2Wins,
    setWhoWins,
    playAgain,
    undo,
    wait,
    setWait,
    winnerPos,
    pause,
    setPause } = usePlay()

  return (
    <div className='container game-container'>
      <div className='menu__container'>
        <button className='game__button menu__button' onClick={() => setPause(true)}>MENU</button>
        <Logo />
        <button className='game__button restart__button' onClick={() => undo(cpu)}>UNDO</button>
      </div>

      <div className='game__container'>
        <article className='player__card player-1-card'>
          <img src={(cpu === 1) ? PLAYERCPURED :PLAYER1} alt="" />
          <h2>{(cpu === 1) ? 'CPU' : 'PLAYER 1'}</h2>
          <p>{player1Wins}</p>
        </article>

        <div className='game__board'>

          <div className='white-board' style={{ backgroundImage: `url(${WITHEBOARD})` }}></div>
          <div className='black-board' style={{ backgroundImage: `url(${BLACKBOARD})` }}></div>

          <Grid grid={grid}
            setNewDisk={setNewDisk}
            winner={winner}
            wait={wait}
            setWait={setWait}
            player={player}
            winnerPos={winnerPos}
            width={width}
            cpu={cpu} />

        </div>

        <article className='player__card player-2-card'>
          <img src={(cpu === 2) ? PLAYERCPU : PLAYER2} alt="" />
          <h2>{(cpu === 2) ? 'CPU' : 'PLAYER 2'}</h2>
          <p>{player2Wins}</p>
        </article>

        {!winner && <Timer timerCounter={timerCounter}
          player={player}
          setTimerCounter={setTimerCounter}
          winner={winner}
          setWhoWins={setWhoWins}
          pause={pause}
          cpu={cpu} />}

        {winner && !wait && <Winner winner={winner}
          playAgain={playAgain}
          cpu={cpu} />}

      </div>



      <div className={(winner === 1) ? 'winner-color winner-red' : ((winner === 2)) ? 'winner-color winner-yellow' : 'winner-color'}></div>

      {pause && (
        <Modal setPause={setPause}>
          <div className='modal__content'>
            <p>PAUSE</p>
            <button className='modal__button white-button' onClick={() => setPause(false)}>CONTINUE GAME</button>
            <button className='modal__button white-button' onClick={() => { setPause(false); playAgain(true); }}>RESTART</button>
            <Link to='/' className='modal__button red-button' onClick={() => playAgain(true)}>QUIT GAME</Link>
          </div>
        </Modal>)
      }

    </div>
  )
}

export { Game }